var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "36px",
    viewBox: "0 0 48 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Building Blocks / 24x24 ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MVP---contact-us",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.2-Powerup-issue",
    transform: "translate(-696.000000, -487.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Overlays-/-Fullscreen-Takeover-/-Sample-Set-/-Large-/-Prompt",
    transform: "translate(0.000000, 92.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dialog",
    transform: "translate(312.000000, 306.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Building-Blocks-/-24x24-",
    transform: "translate(396.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    fill: "#00095B"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Checkmark",
    points: "33.1695926 -6 3.99865603 24.1528132 -9.16959261 10.5371614 -12 13.458671 3.99865603 30 36 -3.07015513 36 -3.07849039 33.1776564 -6"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Keyboard-Focus",
    x: -8,
    y: -8,
    width: 40,
    height: 40
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccept);
export default __webpack_public_path__ + "static/media/accept.c01507d2f3ec1f46427983502d3fd6d0.svg";
export { ForwardRef as ReactComponent };